import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const OrganizationPages = {
  list: 'ListOrganization',
  add: 'AddOrganization',
  edit: 'EditOrganization',
}

const { t } = i18n.global

const title = t('pages.listOrganization')
const path = '/organizations'
const breadcrumb = [{ title, path }]

const organizationFormComponent = () =>
  import('@/pages/mainPageWithRoute/organization/FormOrganizationPage.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: OrganizationPages.add,
  component: organizationFormComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: OrganizationPages.edit,
  component: organizationFormComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: OrganizationPages.list,
  component: () => import('@/pages/mainPageWithRoute/organization/ListOrganizationPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Organizations: RouteRecordRaw = {
  path,
  name: 'Organizations',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
